
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-decisioning/custom-destinations",
      function () {
        return require("private-next-pages/ai-decisioning/custom-destinations.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-decisioning/custom-destinations"])
      });
    }
  